import { AdminShell } from '@/components/admin-shell';
import { Outlet } from 'react-router-dom';

export function AdminLayout() {
  return (
    <AdminShell>
      <Outlet />
    </AdminShell>
  );
}
